<template>
  <div>
    <Row>
      <Col span="11">
        <FormItem :label="$t( 'resourceLifecycle.name' )" prop="name">
          <Input v-model="resourceApplicationForm.name" :placeholder="$t( 'resourceLifecycle.pleaseenter' )"/>
        </FormItem>
      </Col>
      <Col span="11">
        <FormItem :label="$t( 'resourceLifecycle.publicaccesslevel' )" prop="pulicLevel">
          <Select v-model="resourceApplicationForm.pulicLevel" filterable>
            <Option :value="item.id" v-for="item in pulicLevelList" v-bind:key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem :label="$t( 'resourceLifecycle.storageAccounts' )" prop="storageAccount">
          <Select v-model="resourceApplicationForm.storageAccount" filterable>
            <Option :value="item.storageAccountName" v-for="item in storageAccountList"
                    v-bind:key="item.storageAccountName">{{item.storageAccountName}}
            </Option>
          </Select>
        </FormItem>
      </Col>
    </Row>
  </div>
</template>

<script>
  export default {
    name: 'AzureObjectStorage',
    props: ['azureResourceApplicationBasicInfoForm','cost'],
    components: {},
    data() {
      return {
        pulicLevelList: [{
          id: 0,
          name: this.$t( 'resourceLifecycle.blobonlyanonymousreadaccessBlob)' )
        }, {
          id: 1,
          name: this.$t( 'resourceLifecycle.containeranonymousreadaccessblob))' )
        }, {
          id: 2,
          name: this.$t( 'resourceLifecycle.dedicatednoanonymousaccess))' )
        }],
        storageAccountList: [],
        resourceApplicationForm: {
          name: '',
          pulicLevel: '',
          storageAccount: '',
          cost:0
        },
        ruleValidate: {
          name: [
            {required: true, message: this.$t( 'resourceLifecycle.namecannotbeempty' ), trigger: 'blur'}
          ],
          pulicLevel: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectPublicAccessLevel' ), trigger: 'change', type: 'number'}
          ],
          storageAccount: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectastorageaccount' ), trigger: 'change'}
          ]
        }
      }
    },
    mounted: function () {
    },
    methods: {
      showAll: function () {
        //查询存储账户
        this.queryAzureStorageAccounts();
        this.queryAzureObjectStoragePrice();
      },
      //查询价格
      queryAzureObjectStoragePrice: function () {
        var submitLifecycleResourceApplicationDTO = {
          "duration": this.azureResourceApplicationBasicInfoForm.periodOfUse,
          "region": this.azureResourceApplicationBasicInfoForm.region
        }
        this.$api.azurePrice.queryAzureObjectStoragePrice(submitLifecycleResourceApplicationDTO)
          .then(res => {
            this.resourceApplicationForm.cost = res.data
            this.$emit('success', this.resourceApplicationForm.cost);
          })
      },
      //查询存储账户
      queryAzureStorageAccounts: function () {
        this.$api.lifecycleResourceApplication.queryAzureStorageAccounts({
          "accountId": this.azureResourceApplicationBasicInfoForm.accountId
        })
          .then(res => {
            if (res.data) {
              this.storageAccountList = res.data;
              this.resourceApplicationForm.storageAccount = this.storageAccountList[0].storageAccountName;
            }

          })
      }
    }
  }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_application/azure/object_storage/AzureObjectStorage.vue